<template>
  <div class="m-create-user-new row no-gutters">
    <base-input
      v-model="value.email"
      v-validate="'required|email'"
      class="-address-form"
      type="text"
      :label="$t('createUserNewEmail', 'Email')"
      name="create-user-new-email"
      :error-message="$t('createUserNewEmailErrorMsg', 'Indtast venligst din email')"
      :aria-label="$t('createUserNewEmail', 'Email')"
      show-feedback-icon
      required
    />
    <base-input
      v-model="value.fullName"
      v-validate="'required'"
      class="-address-form"
      type="text"
      :label="$t('createUserNewFullName', 'Fulde navn')"
      name="create-user-new-full-name"
      :error-message="$t('createUserNewFullNameErrorMsg', 'Indtast venligst dit fulde navn')"
      :aria-label="$t('createUserNewFullName', 'Fulde navn')"
      show-feedback-icon
      :max-input-length="50"
      required
    />
    <base-input
      v-model="value.companyName"
      v-validate="'required'"
      class="-address-form"
      type="text"
      :label="$t('createUserNewCompanyName', 'Firmanavn')"
      name="create-user-new-company-name"
      :error-message="$t('createUserNewCompanyNameErrorMsg', 'Indtast venligst dit firmanavn')"
      :aria-label="$t('createUserNewCompanyName', 'Firmanavn')"
      show-feedback-icon
      required
    />
    <base-input
      v-model="value.companyCvrNumber"
      v-validate="{ required: true, regex: cvrValidation }"
      class="-address-form"
      type="text"
      :label="$t('createUserNewBillingCompanyCvrNumber', 'Firma CVR nummer')"
      name="create-user-new-company-cvr-number"
      :error-message="$t('createUserNewCompanyCvrNumberErrorMsg', 'Indtast venligst dit firma cvr nummer')"
      :aria-label="$t('createUserNewCompanyCvrNumber', 'Firma CVR nummer')"
      maxlength="14"
      show-feedback-icon
      required
    />
    <base-input
      v-model="value.companyEanNumber"
      class="-address-form"
      type="text"
      :label="$t('createUserNewBillingCompanyEanNumber', 'Firma EAN nummer')"
      name="create-user-new-company-ean-number"
      :aria-label="$t('createUserNewBillingCompanyEanNumber', 'Firma EAN nummer')"
      show-feedback-icon
    />
    <base-input
      v-model="value.billingInformation.address"
      v-validate="'required'"
      class="-address-form"
      type="text"
      :label="$t('createUserNewBillingAddress', 'Adresse')"
      name="create-user-new-billing-address"
      :error-message="$t('createUserNewBillingAddressErrorMsg', 'Indtast venligst din adresse')"
      :aria-label="$t('createUserNewBillingAddress', 'Adresse')"
      show-feedback-icon
      :max-input-length="50"
      required
    />
    <div class="col-md-3">
      <base-input
        v-model="value.billingInformation.zipCode"
        v-validate="'required'"
        class="-address-form"
        type="text"
        :label="$t('createUserNewBillingZipCode', 'Postnummer')"
        name="create-user-new-billing-zip-code"
        :error-message="$t('createUserNewBillingZipCodeErrorMsg', 'Indtast venligst et gyldigt postnummer')"
        :aria-label="$t('createUserNewBillingZipCode', 'Postnummer')"
        show-feedback-icon
        required
      />
    </div>
    <div class="col-md-9 pl-md-4">
      <base-input
        v-model="value.billingInformation.city"
        v-validate="'required'"
        class="-address-form"
        type="text"
        :label="$t('createUserNewBillingCity', 'By')"
        name="create-user-new-billing-city"
        :error-message="$t('createUserNewBillingCityErrorMsg', 'Indtast venligst en gyldig by')"
        :aria-label="$t('createUserNewBillingCity', 'By')"
        show-feedback-icon
        required
      />
    </div>
    <base-input
      v-model="value.phoneNumber"
      v-validate="'required'"
      class="-address-form"
      type="text"
      :label="$t('createUserNewPhone', 'Telefonnummer')"
      name="create-user-new-phone"
      :error-message="$t('createUserNewPhoneErrorMsg', 'Indtast venligst dit telefonnummer')"
      :aria-label="$t('createUserNewPhone', 'Telefonnummer')"
      show-feedback-icon
      required
    />
    <base-input
      v-model="value.invoiceEmail"
      v-validate="'required|email'"
      class="-address-form"
      type="text"
      :label="$t('createUserNewInvoiceEmail', 'Faktura email')"
      name="create-user-new-invoice-email"
      :error-message="$t('createUserNewInvoiceEmailErrorMsg', 'Indtast venligst din faktura email')"
      :aria-label="$t('createUserNewInvoiceEmail', 'Faktura email')"
      show-feedback-icon
      required
    />
    <base-input
      v-model="value.accountStatementEmail"
      class="-address-form"
      type="text"
      :label="$t('createUserNewAccountStatementEmail', 'Kontoudtog email')"
      name="create-user-new-account-statement-email"
      :error-message="$t('createUserNewAccountStatementEmailErrorMsg', 'Indtast venligst din kontoudtog email')"
      :aria-label="$t('createUserNewAccountStatementEmail', 'Kontoudtog email')"
      show-feedback-icon
    />
    <div class="mb-5 row no-gutters">
      <base-checkbox
        v-model="value.differentShippingAddress"
        name="different-shipping-address"
        :label="$t('createUserAlternativeShippingAddress', 'Anden leveringsadresse?')"
        class="my-4"
      />
      <template v-if="value.differentShippingAddress">
        <base-input
          v-model="value.shippingInformation.address"
          v-validate="'required'"
          class="-address-form"
          type="text"
          :label="$t('createUserNewShippingAddress', 'Adresse')"
          name="create-user-new-shipping-address"
          :error-message="$t('createUserNewShippingAddressErrorMsg', 'Indtast venligst din adresse')"
          :aria-label="$t('createUserNewShippingAddress', 'Adresse')"
          show-feedback-icon
          required
        />
        <div class="col-3">
          <base-input
            v-model="value.shippingInformation.zipCode"
            v-validate="'required'"
            class="-address-form"
            type="text"
            :label="$t('createUserNewShippingZipCode', 'Postnummer')"
            name="create-user-new-shipping-zip-code"
            :error-message="$t('createUserNewShippingZipCodeErrorMsg', 'Indtast venligst et gyldigt postnummer')"
            :aria-label="$t('createUserNewShippingZipCode', 'Postnummer')"
            show-feedback-icon
            required
          />
        </div>
        <div class="col-9 pl-md-4">
          <base-input
            v-model="value.shippingInformation.city"
            v-validate="'required'"
            class="-address-form"
            type="text"
            :label="$t('createUserNewShippingCity', 'By')"
            name="create-user-new-shipping-city"
            :error-message="$t('createUserNewShippingCityErrorMsg', 'Indtast venligst en gyldig by')"
            :aria-label="$t('createUserNewShippingCity', 'By')"
            show-feedback-icon
            required
          />
        </div>
      </template>
    </div>
    <base-input
      ref="password"
      v-model="value.password"
      v-validate="'required|min:8'"
      type="password"
      :label="$t('createUserNewPassword', 'Adgangskode')"
      name="password"
      :custom-error-messages="{
        required: $t('createUserNewPasswordRequiredErrorMessage', 'Udfyld venligst en gyldig adgangskode'),
        min: $t('createUserNewPasswordMinErrorMessage', 'Adgangskoden skal være på minimum 8 karakterer')
      }"
      :show-feedback-icon="true"
      :aria-label="$t('createUserNewPassword', 'Adgangskode')"
      required
      class="-address-form"
    />
    <base-input
      v-model="value.passwordConfirm"
      v-validate="'required|confirmed:password'"
      type="password"
      :label="$t('createUserNewPasswordConfirm', 'Bekræft adgangskode')"
      name="password-confirm"
      :error-message="$t('createUserNewPasswordConfirmInvalid', 'Adgangskode svarer ikke til hinanden')"
      :show-feedback-icon="true"
      :aria-label="$t('createUserNewPasswordConfirm', 'Bekræft ny adgangskode')"
      required
      class="-address-form"
    />
    <div class="d-flex flex-grow-1 justify-content-center mt-9">
      <button-with-loader
        :loading="isLoading"
        :text="$t('createUserSubmit', 'Indsend til godkendelse')"
        class="-primary py-4"
        @click.native="submitForm"
      />
    </div>
    <div v-if="showError" class="col-12 bg-red color-white p-4 mt-4">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/atoms/BaseInput'
import BaseCheckbox from '@/components/atoms/BaseCheckbox'
import ButtonWithLoader from '@/components/molecules/ButtonWithLoader'
import { trackFormSubmission } from '@/utils/enhancedTracking'

export default {
  name: 'CreateUserNew',
  components: {
    BaseInput,
    BaseCheckbox,
    ButtonWithLoader
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      showError: false,
      errorMessage: ''
    }
  },
  computed: {
    currentCulture() {
      return this.$store.getters['site/getCurrentCulture']
    },
    generalErrorMessage() {
      return this.$t(
        'CreateUserNewUserAlreadyExistsErrorMessage',
        'Det ser ud til at en konto med denne email allerede findes. Nulstil eventuelt kodeordet for at få adgang.'
      )
    },
    cvrValidation() {
      return /^(S|s)(E|e)[0-9]{12}$|^[0-9]{6}$|^[0-9]{8}$|^[0-9]{9}$/
    }
  },
  methods: {
    async submitForm() {
      this.showError = false
      this.isLoading = true
      const allFieldsValid = await this.$validator.validate()

      if (!allFieldsValid) {
        /**
         * Could we do this easier?
         */
        const yOffset = -125
        const fieldName = this.errors.items[0].field
        const element = document.getElementById(fieldName)
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset

        window.scrollTo({ top: y, behavior: 'smooth' })

        this.isLoading = false
        return
      }

      const fullName = this.value.fullName
      let firstName = ''
      let lastName = ''

      if (fullName.includes(' ')) {
        firstName = fullName.substring(0, fullName.lastIndexOf(' '))
        lastName = fullName.substring(fullName.lastIndexOf(' ') + 1, fullName.length)
      } else {
        firstName = fullName
      }

      // Default using billing for shipping - use shipping if checkbox is checked
      let formattedShippingInformation = {
        shippingAddress: this.value.billingInformation.address,
        shippingPostCode: this.value.billingInformation.zipCode,
        shippingCity: this.value.billingInformation.city
      }
      if (this.value.differentShippingAddress) {
        formattedShippingInformation = {
          shippingAddress: this.value.shippingInformation.address,
          shippingPostCode: this.value.shippingInformation.zipCode,
          shippingCity: this.value.shippingInformation.city
        }
      }

      const formattedFormData = {
        email: this.value.email,
        username: this.value.email,
        properties: {
          NewPassword: this.value.password,
          firstName: firstName,
          lastName: lastName,
          cvrNumber: this.value.companyCvrNumber,
          eANNo: this.value.companyEanNumber ?? '',
          phoneNumber: this.value.phoneNumber,
          invoiceEmail: this.value.invoiceEmail,
          accountStatementEmail: this.value.accountStatementEmail,
          companyName: this.value.companyName,
          billingAddress: this.value.billingInformation.address,
          billingPostCode: this.value.billingInformation.zipCode,
          billingCity: this.value.billingInformation.city,
          ...formattedShippingInformation
        }
      }

      try {
        const updateUser = false
        const data = await this.$repositories.users.create(this.currentCulture, formattedFormData, updateUser)

        if (data?.isValid) {
          trackFormSubmission('Create User New', 'Content', this.value.email)
          this.$emit(
            'success',
            this.$t(
              'CreateUserNewCreatedMessage',
              'Tillykke! Du har nu sendt din konto til godkendelse. Vi har sendt dig en mail med yderligere oplysninger'
            )
          )
          this.isLoading = false
          return
        }

        this.errorMessage = this.generalErrorMessage
        this.showError = true
      } catch (error) {
        this.errorMessage = this.generalErrorMessage
        this.showError = true
      }

      this.isLoading = false
    }
  }
}
</script>
